require('rgpd/rgpdCookie');

RgpdCookie.eat({
	language: 'fr_FR',
	privacyPolicyURL: 'https://www.sigma-photo.fr/content/201-conditions-generales-de-vente-a-distance',
	bannerLayout: 'bottom',
	disableAcceptThroughInteraction: true,
	cookiesInfos: [
		{
			name: "Prestashop",
			category: "functional",
			description: "Permet de naviguer sur le site",
			privacyUrl: "https://www.sigma-photo.fr/content/201-conditions-generales-de-vente-a-distance",
		},
		{
			name: "Google Analytics",
			category: "analytics",
			description: "Permet d'analyser les statistiques de consultation de notre site",
			privacyUrl: "https://policies.google.com/privacy",
			gaId: "G-DKPDDKCLP6"
		},
		// {
		// 	name: "New Relic",
		// 	category: "functional",
		// 	description: "Permet de détecter les problèmes de navigation notre site",
		// 	privacyUrl: "https://docs.newrelic.com/docs/browser/browser-monitoring/page-load-timing-resources/new-relic-cookies-used-browser#gdpr",
		// },
		// {
		// 	name: "Google Conversion Tracking",
		// 	category: "analytics",
		// 	description: "Ce cookie permet de mesurer la performance des annonces du premier click jusqu'à l'achat.",
		// 	privacyUrl: "https://policies.google.com/privacy"
		// }
	],
	translations: {
		fr_FR: {
		  'bannerTemplate.description': 'Nous utilisons des cookies, y compris des cookies tiers, afin d’assurer le bon fonctionnement du site, analyser le trafic et optimiser la performance du site.',
		},
	},


});

if( typeof gtagEvent != 'undefined' ){
 	RgpdCookie.fireEvent(gtagEvent);
}

$(document).ready(function(){

	$('.add_to_cart').on('click', function(e){
		RgpdCookie.fireEvent({
        	'event': 'addToCart',
        	'data': gtagEvent.data
    	});
	});

});


/* add in footer to open modal
<a href='#' title="{l s='Gestion des cookies'}" data-choc-action="presentModal" class="link_2">
	{l s='Gestion des cookies'}
</a>
*/


// WEBPACK FOOTER //
// ./js/rgpd/rgpd.js